import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  section: {
    paddingBottom: theme.spacing(2),
  },
}));
